<template lang="pug">
section.bg-light.py-5
  h2.text-center.pb-4(v-if="title") {{ title }}
  .container.d-flex.justify-content-center.align-items-center
    swiper.swiper-container.i_mlr_2(:options="swiperOption", ref="mySwiper")
      swiper-slide.swiper-slide(
        v-for="(iconItem, index) in iconList",
        :key="index"
      )
        icon(:content="iconItem", @click.native="iconClick(iconItem)")
    .swiper-prev(v-if="prevBtnShow", @click="prevClick")
      font-awesome-icon(:icon="['fas', 'chevron-right']", rotation="180") 
    .swiper-next(v-if="nextBtnShow", @click="nextClick")
      font-awesome-icon(:icon="['fas', 'chevron-right']") 
</template>

<script>
import Icon from "@/components/home/Icon";
import { mixins } from "@/mixins/mixins.js";

export default {
  name: "IconCarousel",
  mixins: [mixins],
  props: {
    iconList: Array,
    title: String,
  },
  components: { icon: Icon },
  data() {
    var self = this;

    //初始slider可見個數
    let views;

    if (document.body.clientWidth < 480) {
      views = 3;
    } else if (document.body.clientWidth < 600) {
      views = 4;
    } else if (document.body.clientWidth < 1024) {
      views = 5;
    } else {
      views = 7;
    }

    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: views,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        on: {
          resize: function () {
            self.updateSliders();
            this.update();
          },
          slideChangeTransitionEnd: function (data) {
            if (
              data.activeIndex <
              self.iconList.length - self.swiperOption.slidesPerView
            ) {
              self.nextBtnShow = true;
            } else {
              self.nextBtnShow = false;
            }
            if (data.activeIndex > 0) {
              self.prevBtnShow = true;
            } else {
              self.prevBtnShow = false;
            }
          },
        },
      },
      prevBtnShow: false,
      nextBtnShow: true,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  watch: {
    iconList() {
      this.initPrevNext();
    },
  },
  methods: {
    initPrevNext() {
      if (this.iconList.length <= this.swiperOption.slidesPerView) {
        this.prevBtnShow = false;
        this.nextBtnShow = false;
      } else {
        this.prevBtnShow = false;
        this.nextBtnShow = true;
      }
    },
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },

    updateSliders() {
      if (document.body.clientWidth < 480) {
        this.swiper.params.slidesPerView = 3;
        this.swiperOption.slidesPerView = 3;
      } else if (document.body.clientWidth < 600) {
        this.swiper.params.slidesPerView = 4;
        this.swiperOption.slidesPerView = 4;
      } else if (document.body.clientWidth < 1024) {
        this.swiper.params.slidesPerView = 5;
        this.swiperOption.slidesPerView = 5;
      } else {
        this.swiper.params.slidesPerView = 7;
        this.swiperOption.slidesPerView = 7;
      }
      this.initPrevNext();
    },
    iconClick(iconItem) {
      this.linkClick(iconItem.link);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/icon_carousel";
</style>
